//dependencias
import React, { Component } from 'react';

//componentes
import PlanEAction from './planEvaluacion'

class Index extends Component {

    render(){
        return(
            <div>
                <PlanEAction />
            </div>
        );
    }

}
export default Index;